module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADhSURBVFiF7dfNDYJAEIbhdwgFUAJ2YAuWYAVqJdoBdmTsgBIogQ7Ggxx0RQkxHz/JPCeyLOHNBA5rDHB3H9ozpWzugLEiWC0f+4CZmSLkm/QfWt2EI1gtgtUiWC2C1SJYLYLVIlgtX9qZbcjqJhzBah9nuvTMtrRvfHUTjmC1CFaLYLUIVotgtQhWy4D2dcHdy77rTsuE+t6fAXWyWLl72W2uknvpXplv7zd3vwDnqUL+dDJ3L4AbsJ27ZkBjZpvMzFpgDzQzB/1SAzuA9Dh0BA48p11MnvWu5Rl6B67dYHkAN5M+gDAFSYsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fengcai.png
// module id = t9OC
// module chunks = 265